<dashboardnav>
    <cradua-landprefix
    [landPrefixs]="landPrefixs$ | async"
    (landPrefix)="onSubmitLandPrefix($event)"
    (deleteLandPrefixEvent)="onDeleteLandPrefix($event)"
    *ngIf="(isLoadingLandPrefix$ | async ) === false"
    >
  </cradua-landprefix>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingLandPrefix$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
